module.exports = __webpack_public_path__ + "img/feature_buy_ph.5e8a946d.png";